import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#9FA1A6",
  d: "M12.8 7.201a.625.625 0 0 1 0 .884L10.883 10l1.915 1.915a.625.625 0 1 1-.883.884L10 10.884l-1.915 1.915a.625.625 0 1 1-.884-.884L9.116 10 7.201 8.085a.625.625 0 0 1 .884-.884L10 9.116l1.915-1.915a.625.625 0 0 1 .884 0Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#9FA1A6",
  "fill-rule": "evenodd",
  d: "M1.042 10a8.958 8.958 0 1 1 17.917 0 8.958 8.958 0 0 1-17.917 0ZM10 2.292a7.708 7.708 0 1 0 0 15.416 7.708 7.708 0 0 0 0-15.416Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }